import dayjs, { extend } from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

extend(relativeTime)

const DEFAULT_LANGUAGE = 'en'

const getFormattedDate = (date: string, format: string = 'DD/MM/YYYY') => dayjs(date).format(format)

export const getFormattedRelativeTime = (date: string) => dayjs(date).from(dayjs())

export const getFormattedDateByLanguage = (date: string, language: string = DEFAULT_LANGUAGE) => {
  if (!date || typeof date !== 'string') {
    return ''
  }

  const dateObj = dayjs(date)
  if (!dateObj.isValid()) {
    return ''
  }

  const formats = {
    en: 'MM/DD/YYYY',
    'pt-BR': 'DD/MM/YYYY',
    es: 'DD/MM/YYYY',
  }

  const format = language in formats ? formats[language as keyof typeof formats] : formats[DEFAULT_LANGUAGE]
  return getFormattedDate(date, format)
}

export const getRelativeDayInfo = (
  date: string | Date,
  language: string = DEFAULT_LANGUAGE
): { isToday: boolean; time: string } | null => {
  if (!date) return null

  const dateObj = dayjs(date)
  if (!dateObj.isValid()) return null

  const time = new Intl.DateTimeFormat(language, {
    hour: 'numeric',
    minute: '2-digit',
  }).format(dateObj.toDate())

  return {
    isToday: dateObj.isSame(dayjs(), 'day'),
    time,
  }
}

export const getFormatted12HourTime = (date: string): string => {
  if (!date || typeof date !== 'string') {
    return ''
  }

  const dateObj = dayjs(date)
  if (!dateObj.isValid()) {
    return ''
  }

  return dateObj.format('h:mmA')
}

export const getFormattedLongDate = (date: string, locale: string = 'en'): string => {
  if (!date) return ''
  const dateObj = new Date(date)
  if (isNaN(dateObj.getTime())) return ''
  return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long', year: 'numeric' }).format(dateObj)
}

export default getFormattedDate
